(function () {
  if (window.__kodifChatTriggerBound) return;
  window.__kodifChatTriggerBound = true;

  window.openKodifChat = function () {
    const iframe = document.getElementById('kodif-chat-widget');
    if (!iframe || !iframe.contentWindow) return false;
    iframe.contentWindow.postMessage({ type: 'toggle-expanded', isExpanded: true }, '*');
    return true;
  };

  document.addEventListener('click', function (event) {
    const trigger = event.target.closest('#start-chatbot, .chat-now-button, body.page-contact-us a[href*="/policies/contact-information"].button');
    if (!trigger) return;
    event.preventDefault();
    window.openKodifChat();
  });
})();
